import { DEFAULT_MINOR_UNITS } from "@/data/currencyUnits";
import { multiplyPrice } from "@/utils/multiplyPrice";
import { resolveMinorUnits } from "@/utils/resolveMinorUnits";
import { TCartItem } from "../types.checkout";
import { isBundleInCart } from "./bundleUtils";

const isUndefined = (value: unknown): value is undefined => value === undefined;

export const sumItemPrices = (
  items: TCartItem[],
  currency: string,
): number | undefined => {
  const minorUnits = resolveMinorUnits(currency) ?? DEFAULT_MINOR_UNITS;
  const lines = items.map((item) => multiplyPrice(item.price, item.quantity));

  if (lines.some(isUndefined)) return undefined;

  const totalMinor = lines.reduce<number>(
    (total, line) => total + Math.round((line ?? 0) * minorUnits),
    0,
  );

  return totalMinor / minorUnits;
};

export const getRenewalAmount = ({
  newPlans,
  newAddOns,
  ownedPlans,
  ownedAddOns,
  currency,
}: {
  newPlans: TCartItem[];
  newAddOns: TCartItem[];
  ownedPlans: TCartItem[];
  ownedAddOns: TCartItem[];
  currency: string;
}): number | undefined =>
  sumItemPrices(
    [
      ...newPlans,
      ...newAddOns,
      ...(isBundleInCart(newPlans) ? [] : ownedPlans),
      ...ownedAddOns,
    ],
    currency,
  );
